module.exports = __webpack_public_path__ + "img/product-2-tu.9d34f8d1.png";